import React from "react"
import SidebarBlock from "components/shared/SidebarBlock"
import styled from "styled-components"
import { Row, Col } from "reactstrap"
import { media } from "utils/Media"
import ContainerMax from "components/shared/ContainerMax"

const ContainerMaxStyled = styled(ContainerMax)`
  .content {
    @media ${media.lg} {
      width: 940px;
      max-width: calc(100% - 330px);
    }
  }

  .sidebar {
    width: 100%;
    display: block;
    @media ${media.lg} {
      max-width: 330px;
    }
  }
`

export default function TextWithSidebarBlock({block}) {
  const { title, text, sidebarBlock } = block
  return(
    <ContainerMaxStyled
      maxWidth="1360"
      className="py-4 py-md-5"
    >
      {title && (
        <h1 className="text-center pb-4">{title}</h1>
      )}
      <Row className="justify-content-lg-between">
        <Col xs={12} lg="auto" className="content pb-4 pb-lg-0">
          <div dangerouslySetInnerHTML={{ __html: text }} />
        </Col>
        <Col xs={12} lg="auto" className="sidebar">
          <Row className="justify-content-center">
            {sidebarBlock?.map((node, i) => {
              switch (node.acfSidebarBlocks.sidebarBlockType[0].__typename) {
                case "WpSidebarBlock_Acfsidebarblocks_SidebarBlockType_ImageLink":
                  return(
                    <Col xs={12} className="pb-3 pb-md-0 px-lg-0" key={i}>
                      <SidebarBlock id={node.databaseId} margin={true} />
                    </Col>
                  )

                case "WpSidebarBlock_Acfsidebarblocks_SidebarBlockType_Rolex":
                  return(
                    <Col xs={12} className="pb-3 pb-md-0 px-lg-0" key={i}>
                      <SidebarBlock id={node.databaseId} margin={true} />
                    </Col>
                  )
            
                default:
                  return null
              }
            })}
          </Row>
        </Col>
      </Row>
    </ContainerMaxStyled>
  )
}